/**
* StoreController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';StoreController.$inject = ["$q", "$rootScope", "$http", "$analytics", "$state", "$window", "$localStorage", "plansResolved", "uid", "affilate", "Survey", "Profile", "mesSystem", "MeasurementSystem", "currency", "UserService"];

  angular.
  module('gplans.store.controllers').
  controller('StoreController', StoreController);

  StoreController.$inject = ['$q', '$rootScope', '$http', '$analytics', '$state', '$window', '$localStorage', 'plansResolved', 'uid',
  'affilate', 'Survey', 'Profile', 'mesSystem', 'MeasurementSystem', 'currency', 'UserService'];

  /**
                                                                                                 * @namespace StoreController
                                                                                                 */
  function StoreController($q, $rootScope, $http, $analytics, $state, $window, $localStorage, plansResolved, uid,
  affilate, Survey, Profile, mesSystem, MeasurementSystem, currency, UserService) {
    var vm = this;
    vm.linkClicked = linkClicked;
    var _plansIds = {};
    var _plansFlowIds = {};

    activate();

    function activate() {

      vm.user = UserService.data;

      $window.gplansStorage.alreadySeenVideo = true;

      MeasurementSystem.setMeasurementSystem(mesSystem).then(function (res) {
        console.log(res);
      });

      vm.looseWeight = UserService.data.current_weight - UserService.data.goal_weight;
      vm.goalWeight = UserService.data.goal_weight;
      if (mesSystem == 'SI') {
        vm.weightUnit = 'kg';
        vm.heightUnit = 'cm';
        vm.looseWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.looseWeight));
        vm.goalWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.goalWeight));
      } else
      {
        vm.weightUnit = 'lbs';
        vm.heightUnit = 'inches';
      }

      if (currency == 'USD') vm.currencyToPlan = '';else
      vm.currencyToPlan = '-' + currency.toLowerCase();

      if (currency == 'GBP') {
        vm.currencySymbol = '£';
        vm.promiseCost = 79;
        vm.proCost = 29.99;
        vm.minusCost = 10;
      } else
      if (currency == 'AUD' || currency == 'CAD') {
        vm.currencySymbol = currency + '$';
        vm.promiseCost = 129;
        vm.proCost = 49.99;
        vm.minusCost = 20;
      } else
      {
        vm.currencySymbol = '$';
        vm.promiseCost = 99;
        vm.proCost = 39.99;
        vm.minusCost = 20;
      }

      /////// Marketing tracking
      if (affilate) {
        var props = {};
        for (var key in affilate) {
          if (affilate.hasOwnProperty(key)) {
            props['Affilate_' + key] = affilate[key];
          }
        }
        $analytics.setUserProperties(props);

        window.ga('set', 'dimension1', affilate['type']);
        window.ga('set', 'dimension2', affilate['hop'] || affilate['affid']);
      }

      if ($window.localStorage.offerId) {
        var props = {
          'offer_id': $window.localStorage.offerId };

        $analytics.setUserProperties(props);

        window.ga('set', 'dimension3', $window.localStorage.offerId);

        if ($window.heap && angular.isFunction($window.heap.addUserProperties)) {
          heap.addUserProperties({ 'offerId': $window.localStorage.offerId });
        }

        Profile.updateMisc({ key: 'offerId', value: $window.localStorage.offerId }).
        then(function (res) {
          // console.log(res);
        }, function () {
          Profile.createMisc({ key: 'offerId', value: $window.localStorage.offerId });
        });
      }
      /////// END Marketing tracking

      if (affilate && affilate.type === 'Clickbank') {
        vm.clickbank = true;
        if (!$rootScope.clickbankBadgeInstalled) {
          //  <!-- ClickBank Trust Badge -->
          $("<script>").attr({ src: '//cbtb.clickbank.net/?vendor=gplans' }).appendTo("body");
          $rootScope.clickbankBadgeInstalled = true;
        }
      }

      plansResolved.data.forEach(function (plan) {
        _plansIds[plan.slug] = plan.clickbank_item;
        _plansFlowIds[plan.slug] = plan.clickbank_flow_id;
      });

      vm.problems = {};
      var metaPromise =
      $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/' + UserService.data.last_checkin.metabolic_type + '/');
      var surveyPromise =
      Survey.getAnswers(UserService.data.user_survey_id);
      $q.all([
      metaPromise,
      surveyPromise]).
      then(function (res) {
        vm.metabolic_type = res[0].data;

        vm.userSurveyAnswers = res[1].userSurveyAnswers;

        vm.problems = res[1].problems;

        if (vm.problems['restrictions']) {
          if (vm.problems['restrictions'].indexOf('paleo') > -1) {
            vm.restrictionTitle = 'Paleo Diet';
          }
          if (vm.problems['restrictions'].indexOf('vegan') > -1) {
            vm.restrictionTitle = 'Vegan Diet';
          }
          if (vm.problems['restrictions'].indexOf('vegetarian') > -1) {
            vm.restrictionTitle = 'Vegetarian Diet';
          }
          if (vm.problems['restrictions'].indexOf('pescetarian') > -1) {
            vm.restrictionTitle = 'Pescetarian Diet';
          }
        }

        vm.showProblemsBlock = vm.problems['energy'] === 'low energy' ||
        vm.problems['mood'] === 'mood swings' ||
        vm.problems['heart'] === 'heart disease' ||
        vm.problems['diabetes'] === 'diabetes' ||
        vm.problems['stomach'] === 'stomach discomfort';

        if (vm.restrictionTitle) {
          vm.metabolicTitle = vm.metabolic_type.name + ' (' + vm.restrictionTitle + ')';
        } else {
          vm.metabolicTitle = vm.metabolic_type.name;
        }
      });

      $analytics.eventTrack('Plans Page');

    }

    var _errorSent = {}; // save already sent errors not to hit Sentry limits.
    function clickbankLink(plan) {
      if (!_plansIds[plan] && !_errorSent[plan])
      try {
        Raven.captureException(new Error('No Clickbank Item For Plan: ' + plan));
        _errorSent[plan] = true;
      } catch (e) {
        console.log(e.message);
      }


      var url = 'http://' + (_plansIds[plan] ? _plansIds[plan] : 'noitem') + '.gplans.pay.clickbank.net/?cbskin=14999';
      url += _plansFlowIds[plan] ? '&cbfid=' + _plansFlowIds[plan] : ''; // clickbank flow id for product
      url += '&uid=' + uid;

      return url;
    }

    // TODO: DRY refactor - same as in store.controller
    function linkClicked(plan) {
      var props = {};
      props['Plan ' + plan + ' Select'] = 'Plan ' + plan;
      // $analytics.eventTrack('Get Plan Click', props);
      $localStorage['plan'] = plan;

      if (vm.clickbank) {
        $window.location.href = clickbankLink(plan);
      } else {
        $state.go('base.store_payment', { plan: plan });
      }
    }
  }
})();